import type { OpenRouterModel } from "../lib/types";
import { Select } from "./ui";

function sortModels(pool: OpenRouterModel[]): OpenRouterModel[] {
  return [...pool].sort((a, b) => {
    const nameA = (a.name || a.id).toLowerCase();
    const nameB = (b.name || b.id).toLowerCase();
    const byName = nameA.localeCompare(nameB, undefined, { sensitivity: "base" });
    if (byName !== 0) {
      return byName;
    }
    return (a.prompt_per_million ?? 0) - (b.prompt_per_million ?? 0);
  });
}

function buildOptions(pool: OpenRouterModel[], current: string): OpenRouterModel[] {
  const list = sortModels(pool);
  if (current && !list.some((m) => m.id === current)) {
    list.unshift({
      id: current,
      name: `${current} (saved default)`,
      prompt_per_million: 0,
    });
  }
  return list;
}

function formatLabel(m: OpenRouterModel): string {
  if (m.prompt_per_million) {
    return `${m.name} ($${m.prompt_per_million}/M) — ${m.id}`;
  }
  return m.name || m.id;
}

export function OpenRouterModelSelect({
  id,
  label,
  pool,
  value,
  onChange,
  disabled,
}: {
  id: string;
  label: string;
  pool: OpenRouterModel[];
  value: string;
  onChange: (modelId: string) => void;
  disabled?: boolean;
}) {
  const options = buildOptions(pool, value);
  return (
    <div className="mb-3 p-3 bg-surface-container border border-outline-variant">
      <label htmlFor={id} className="font-data-label text-data-label uppercase text-on-surface-variant block mb-2">
        {label}
      </label>
      <Select
        id={id}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.length === 0 && !value ? (
          <option value="">Sync models to load dropdown</option>
        ) : (
          options.map((m) => (
            <option key={m.id} value={m.id}>
              {formatLabel(m)}
            </option>
          ))
        )}
      </Select>
    </div>
  );
}
